<template>
  <section class="relative mt-16 md:py-4 py-4 mt-24">
    <div class="_container flex-row">
      <div class="grid grid-cols-1 text-center">
        <h3 class="mb-4 text-bsd-700 font-bold text-5xl md:text-7xl md:leading-normal text-2xl leading-normal font-semibold">BSD ? <i class="text-8xl uil uil-confused"></i></h3>
        <p class="font-bold text-2xl max-w-xl mx-auto">La solution qui vous fait connaître <span class="text-yellow underline-offset-8">tous les besoins</span> de vos clients... <i class="text-3xl uil uil-laughing"></i></p>
     <div>
      <picture>
  <source srcset="https://fonts.gstatic.com/s/e/notoemoji/latest/1fae0/512.webp" type="image/webp">
  <img src="https://fonts.gstatic.com/s/e/notoemoji/latest/1fae0/512.gif" alt="🫠" width="32" height="32">
</picture>
     </div>
      </div>
    </div>
  </section>

</template>

<script>
export default {

}
</script>

<style></style>